import Link from 'next/link';
import styles from './TestEds.module.scss';

export const SertInstallLinux = () => {
    return (
        <div className={styles.container}>
            <div className={styles.panel}>
                <h1>Установка сертификатов используя КриптоПРО в Linux</h1>
                <p>
                    Описание процесса установки приведено на примере
                    дистрибутива семейства Debian (x64).
                    <br />
                    Названия файлов и директорий могут варьироваться от системы
                    к системе.
                </p>

                <p>
                    При установке <i>личных сертификатов</i> не нужны права
                    суперпользователя, и наоборот, при установке{' '}
                    <i>сертификатов УЦ</i>
                    (корневых и промежуточных) могут потребоваться такие права.
                </p>

                <p>
                    Подключите USB носитель с ключевыми контейнерами и проверьте
                    результат команды:
                </p>
                <pre>
                    <strong>
                        /opt/cprocsp/bin/amd64/csptest -keyset -enum_cont -fqcn
                        -verifyc
                    </strong>
                    <code>
                        {[
                            'CSP (Type:80) v4.0.9009 KC1 Release Ver:4.0.9797 OS:Linux CPU:AMD64 FastCode:READY:AVX.',
                            'AcquireContext: OK. HCRYPTPROV: 16188003',
                            '\\\\.\\FLASH\\ivanov',
                            '\\\\.\\FLASH\\petrov',
                            '\\\\.\\FLASH\\sidorov',
                            '\\\\.\\FLASH\\vasiliev',
                            '\\\\.\\FLASH\\smirnov',
                            'OK.',
                            'Total: SYS: 0,020 sec USR: 0,060 sec UTC: 0,180 sec',
                        ].join('\n')}
                    </code>
                </pre>
                <p>
                    Можно сразу установить личные сертификатов из всех доступных
                    контейнеров одной командой:
                    <br />
                    <strong>
                        /opt/cprocsp/bin/amd64/csptestf -absorb -certs
                    </strong>
                    <br />
                    Произойдет установка сертификатов, находящихся во всех
                    доступных в момент запуска команды контейнерах (съемных
                    флэш-носителях, жесткого диска и т. д.) в хранилище uMy.
                </p>
                <br />

                <h2>
                    Пример установки отдельно взятого сертификата из контейнера
                </h2>

                <p>
                    При необходимости скопируйте ключевой контейнер{' '}
                    <code>\\.\FLASH\.\sidorov</code> на жесткий диск:
                </p>
                <pre>
                    <strong>{`/opt/cprocsp/bin/amd64/csptest -keycopy -contsrc '\\\\.\\FLASH\\sidorov' -contdest '\\\\.\\HDIMAGE\\sidor'`}</strong>
                    <code>
                        {[
                            'CSP (Type:80) v4.0.9009 KC1 Release Ver:4.0.9797 OS:Linux CPU:AMD64 FastCode:READY:AVX.',
                            'CryptAcquireContext succeeded.HCRYPTPROV: 38556259',
                            'CryptAcquireContext succeeded.HCRYPTPROV: 38770755',
                            'Total: SYS: 0,000 sec USR: 0,100 sec UTC: 14,920 sec',
                            '[ErrorCode: 0x00000000]',
                        ].join('\n')}
                    </code>
                </pre>
                <p>
                    <i>
                        Наличие [ErrorCode: 0x00000000] в завершении каждой
                        команды КриптоПРО говорит о ее успешном выполнении.
                    </i>
                </p>
                <br />

                <p>
                    Проверьте наличие нового контейнера{' '}
                    <code>\\.\HDIMAGE\sidor</code>:
                </p>
                <pre>
                    <strong>
                        /opt/cprocsp/bin/amd64/csptest -keyset -enum_cont -fqcn
                        -verifyc
                    </strong>
                    <code>
                        {[
                            'CSP (Type:80) v4.0.9009 KC1 Release Ver:4.0.9797 OS:Linux CPU:AMD64 FastCode:READY:AVX.',
                            'AcquireContext: OK. HCRYPTPROV: 34554467',
                            '\\\\.\\FLASH\\ivanov',
                            '\\\\.\\FLASH\\petrov',
                            '\\\\.\\FLASH\\sidorov',
                            '\\\\.\\FLASH\\vasiliev',
                            '\\\\.\\FLASH\\smirnov',
                            '\\\\.\\HDIMAGE\\sidor',
                            'OK.',
                            'Total: SYS: 0,010 sec USR: 0,050 sec UTC: 0,130 sec',
                            '[ErrorCode: 0x00000000]',
                        ].join('\n')}
                    </code>
                </pre>
                <br />

                <p>Установите личный сертификат:</p>
                <pre>
                    <strong>{`/opt/cprocsp/bin/amd64/certmgr -inst -cont '\\.\HDIMAGE\sidor'`}</strong>
                    <code>
                        {[
                            'Certmgr 1.0 (c) "CryptoPro",  2007-2010.',
                            'program for managing certificates, CRLs and stores',

                            'Install:',
                            '=============================================================================',
                            '1-------',
                            "Issuer              : OGRN=1234567890123, INN=1234567890, STREET=Арбат, E=info@berkut.ru, C=RU, S=77 г.Москва, L=Москва, O=ООО 'Беркут', OU=Удостоверяющий центр, CN=UCESTP",
                            'Subject             : SNILS=12345678901, OGRN=1234567890123, INN=0011234567890, E=sidorov@mail.ru, C=RU, S=10 Республика Карелия, L=Петрозаводск, O=ООО Ромашка, CN=Сидоров Николай Павлович, T=Администратор, G=Николай Павлович, SN=Сидоров',
                            'Serial              : 0x12C40953000000000019',
                            'SHA1 Hash           : 0xdd0ea8db46a372571c55315cd7e4d8e2de8fb9b6',
                            'SubjKeyID           : 5fc37e578cce0abe739c4da227f68a2f9abcb128',
                            'Signature Algorithm : ГОСТ Р 34.11/34.10-2001',
                            'PublicKey Algorithm : ГОСТ Р 34.10-2001 (512 bits)',
                            'Not valid before    : 09/08/2016  06:07:00 UTC',
                            'Not valid after     : 09/11/2017  06:17:00 UTC',
                            'PrivateKey Link     : No',
                            'CA cert URL         : <mark>http://cert1.ucestp.ru/estp.crt</mark>',
                            'Extended Key Usage  : 1.3.6.1.5.5.7.3.4',
                            '1.3.6.1.5.5.7.3.2',
                            '=============================================================================',
                            '[ErrorCode: 0x00000000]',
                        ].join('\n')}
                    </code>
                </pre>
                <p>
                    Скачайте корневой сертификат по ссылке выше (из поля{' '}
                    <code>CA cert URL</code>):
                    <a
                        href="http://cert1.ucestp.ru/estp.crt"
                        target="_blank"
                        rel="noreferrer"
                    >
                        {' http://cert1.ucestp.ru/estp.crt '}
                    </a>
                    и перенесите его, например, в домашнюю папку:
                </p>
                <pre>
                    <strong>cp ~/Загрузки/estp.crt ~/estp.crt</strong>
                </pre>
                <br />

                <p>
                    Установите корневой сертификат (возможно потребуются права
                    суперпользователя):
                </p>
                <pre>
                    <strong>
                        /opt/cprocsp/bin/amd64/certmgr -inst -store uroot -file
                        ~/estp.crt
                    </strong>
                    <code>
                        {[
                            'Certmgr 1.0 (c) "CryptoPro",  2007-2010.',
                            'program for managing certificates, CRLs and stores',

                            'Install:',
                            '=============================================================================',
                            '1-------',
                            "Issuer              : OGRN=1234567890123, INN=1234567890, STREET=Арбат, E=info@berkut.ru, C=RU, S=77 г.Москва, L=Москва, O=ООО 'Беркут', OU=Удостоверяющий центр, CN=UCESTP",
                            "Subject             : OGRN=1234567890123, INN=1234567890, STREET=Арбат, E=info@berkut.ru, C=RU, S=77 г.Москва, L=Москва, O=ООО 'Беркут', OU=Удостоверяющий центр, CN=UCESTP",
                            'Serial              : 0x50D7BC0E4A3EC9994454EB83013EE5F5',
                            'SHA1 Hash           : 0xd2144a3e098b6f2decb224257f48e2b7c6d85209',
                            'SubjKeyID           : 07b753cd561dee8e5e83407be4575ecc05bfec14',
                            'Signature Algorithm : ГОСТ Р 34.11/34.10-2001',
                            'PublicKey Algorithm : ГОСТ Р 34.10-2001 (512 bits)',
                            'Not valid before    : 17/06/2016  13:15:21 UTC',
                            'Not valid after     : 17/06/2021  13:25:01 UTC',
                            'PrivateKey Link     : No',
                            '=============================================================================',
                            '[ErrorCode: 0x00000000]',
                        ].join('\n')}
                    </code>
                </pre>
                <br />

                <p>Проверьте установку личного сертификата:</p>
                <pre>
                    <strong>
                        /opt/cprocsp/bin/amd64/certmgr -list -store uMy
                    </strong>
                    <code>
                        {[
                            'Certmgr 1.0 (c) "CryptoPro",  2007-2010.',
                            'program for managing certificates, CRLs and stores',
                            '=============================================================================',
                            '1-------',
                            "Issuer              : OGRN=1234567890123, INN=1234567890, STREET=Арбат, E=info@berkut.ru, C=RU, S=77 г.Москва, L=Москва, O=ООО 'Беркут', OU=Удостоверяющий центр, CN=UCESTP",
                            'Subject             : SNILS=12345678901, OGRN=1234567890123, INN=0011234567890, E=sidorov@mail.ru, C=RU, S=10 Республика Карелия, L=Петрозаводск, O=ООО Ромашка, CN=Сидоров Николай Павлович, T=Администратор, G=Николай Павлович, SN=Сидоров',
                            'Serial              : 0x12C40953000000000019',
                            'SHA1 Hash           : 0xdd0ea8db46a372571c55315cd7e4d8e2de8fb9b6',
                            'SubjKeyID           : 5fc37e578cce0abe739c4da227f68a2f9abcb128',
                            'Signature Algorithm : ГОСТ Р 34.11/34.10-2001',
                            'PublicKey Algorithm : ГОСТ Р 34.10-2001 (512 bits)',
                            'Not valid before    : 09/08/2016  06:07:00 UTC',
                            'Not valid after     : 09/11/2017  06:17:00 UTC',
                            'PrivateKey Link     : Yes',
                            'Container           : HDIMAGE\\\\sidor.000\\2B01',
                            'Provider Name       : Crypto-Pro GOST R 34.10-2012 KC1 CSP',
                            'Provider Info       : ProvType: 80, KeySpec: 1, Flags: 0x0',
                            'CA cert URL         : http://cert1.ucestp.ru/estp.crt',
                            'Extended Key Usage  : 1.3.6.1.5.5.7.3.4',
                            '1.3.6.1.5.5.7.3.2',
                            '=============================================================================',
                            '[ErrorCode: 0x00000000]',
                        ].join('\n')}
                    </code>
                </pre>
            </div>
        </div>
    );
};
